import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import appMiddleware, { preReducerMiddleware } from './appMiddleware';
import appReducers from './appReducers';

// APIs
import { themesApi } from '@/themes';
import { adminsApi } from 'rtk/query/apis/admins';
import { applicationsApi } from 'rtk/query/apis/applications';
import { brevoApi } from 'rtk/query/apis/brevo';
import { candidatesApi } from 'rtk/query/apis/candidates';
import { agentChatApi } from 'rtk/query/apis/chat';
import { clientsApi } from 'rtk/query/apis/clients';
import { interviewsApi } from 'rtk/query/apis/interviews';
import { jobsApi } from 'rtk/query/apis/jobs';
import { mediaApi } from 'rtk/query/apis/media';
import { miscApi } from 'rtk/query/apis/misc';
import { notificationsApi } from 'rtk/query/apis/notifications';
import { outreachApi } from 'rtk/query/apis/outreach';
import { outreachCandidatesApi } from 'rtk/query/apis/outreachCandidates';
import { questionsApi } from 'rtk/query/apis/questions';
import { scoresApi } from 'rtk/query/apis/scores';
import { templateCommentsApi } from 'rtk/query/apis/templateComments';
import { templatesApi } from 'rtk/query/apis/templates';
import { voiceConversationApi } from 'rtk/query/apis/voiceConversation/index.ts';
export const store = configureStore({
  reducer: appReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(appMiddleware.middleware)
      .prepend(preReducerMiddleware)

      .concat(adminsApi.middleware)
      .concat(templatesApi.middleware)
      .concat(clientsApi.middleware)
      .concat(agentChatApi.middleware)
      .concat(questionsApi.middleware)
      .concat(miscApi.middleware)
      .concat(interviewsApi.middleware)
      .concat(jobsApi.middleware)
      .concat(applicationsApi.middleware)
      .concat(brevoApi.middleware)
      .concat(scoresApi.middleware)
      .concat(candidatesApi.middleware)
      .concat(outreachApi.middleware)
      .concat(outreachCandidatesApi.middleware)
      .concat(voiceConversationApi.middleware)
      .concat(notificationsApi.middleware)
      .concat(templateCommentsApi.middleware)
      .concat(mediaApi.middleware)
      .concat(themesApi.middleware),
  devTools: !import.meta.env.PROD,
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
